import { Box, Tab, Tabs } from "@mui/material";
import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import useAuth from "hooks/useAuth";
import { useNavigate } from "react-router-dom";
import ServiceOperationPage from "views/pages/main/service-operation/ServiceOperationPage";
import ServiceOperationAdmin from "views/pages/main/service-operation/ServiceOperationAdmin";
import ServiceOperationAdmin_Update from "views/pages/main/service-operation/ServiceOperationAdmin_Update";
import ServiceOperationTaller from "views/pages/main/service-operation/ServiceOperationTaller";
import ServiceOperationTaller_Update from "views/pages/main/service-operation/ServiceOperationTaller_Update";
import ServiceOperationPanelAdmin from "views/pages/main/service-operation/ServiceOperationPanel_Admin";

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function ServiceOperationMainComponent({ page, id }) {
  const { user } = useAuth();
  const navigate = useNavigate();

  const isAdmin = user.permissions.includes(
    "ServiceOp:viewAdmin" || "ServiceOp:viewSAdmin",
  );
  const isViewer = user.permissions.includes("ServiceOp:view");
  const pageIndex = {
    "add-product": 0,
    admin: 1,
    "service-operation": 2,
    "admin-panel": 3,
  };

  useEffect(() => {
    setValue(pageIndex[page] ?? 1);
  }, [page]);

  const [value, setValue] = useState(pageIndex[page] ?? 1);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: "100%", backgroundColor: "#FFFFFF" }}>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="basic tabs example"
          variant="fullWidth"
          sx={{
            "& .MuiTabs-indicator": {
              backgroundColor: "#354887",
            },
            "& .Mui-selected": {
              color: "#354887",
            },
          }}
        >
          <Tab
            label="RECEPTION"
            disabled={!isAdmin}
            onClick={() => navigate("/service-operation/ingresar")}
            {...a11yProps(0)}
            sx={{ "&.Mui-selected": { color: "#354887" } }}
          />
          <Tab
            label="MANAGEMENT"
            disabled={!isAdmin}
            onClick={() => navigate("/service-operation/admin")}
            {...a11yProps(1)}
            sx={{ "&.Mui-selected": { color: "#354887" } }}
          />
          <Tab
            label="REPAIR"
            onClick={() => navigate("/service-operation/services_operation")}
            {...a11yProps(2)}
            sx={{ "&.Mui-selected": { color: "#354887" } }}
          />
          <Tab
            disabled={!isAdmin}
            label="SETTINGS"
            onClick={() => navigate("/service-operation/admin/panel")}
            {...a11yProps(3)}
            sx={{ "&.Mui-selected": { color: "#354887" } }}
          />
        </Tabs>
      </Box>
      <CustomTabPanel value={value} index={0}>
        <ServiceOperationPage />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={1}>
        {id ? (
          <ServiceOperationAdmin_Update id={id} />
        ) : (
          <ServiceOperationAdmin />
        )}
      </CustomTabPanel>
      <CustomTabPanel value={value} index={2}>
        {id ? (
          <ServiceOperationTaller_Update id={id} />
        ) : (
          <ServiceOperationTaller />
        )}
      </CustomTabPanel>
      <CustomTabPanel value={value} index={3}>
        <ServiceOperationPanelAdmin />
      </CustomTabPanel>
    </Box>
  );
}
